import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../../api/axios';

export const getDocs = createAsyncThunk(
  'docs/getDocs',
  async ({ id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(
        `/folders/${id}/resources`
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const searchDocs = createAsyncThunk(
  'docs/searchDocs',
  async ({ query }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/resources/search`, {
        resource: {
          search: query,
        },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const uploadDocs = createAsyncThunk(
  'docs/uploadDocs',
  async ({ formData, isUpdate }, { getState, rejectWithValue }) => {
    try {
      let response;
      if (isUpdate.state) {
        response = await securedAxiosInstance.patch(
          `/resources/${isUpdate.doc.id}`,
          formData,
          {
            headers: {
              'Content-Type': 'false',
            },
          }
        );
      } else {
        response = await securedAxiosInstance.post(`/resources`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteDocs = createAsyncThunk(
  'docs/deleteDocs',
  async ({ selectedDocs }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/delete_resources`, {
        resources: { resource_id: selectedDocs },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
